// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-17413cd8] .psf-custom-tab .nav-item .nav-link.active {\r\n  border-bottom: 3px solid #ff7058 !important;\r\n  color: #ff7058 !important;\r\n  font-weight: 700;\n}\r\n", ""]);
// Exports
module.exports = exports;
